var render = function render(){var _vm=this,_c=_vm._self._c;return _c('booking-form',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],attrs:{"booking":_vm.booking,"type":"create"},on:{"save":_vm.createBooking,"cancel":_vm.cancelCreateBooking}})
}
var staticRenderFns = []

export { render, staticRenderFns }